import { DOCUMENT, inject, InjectionToken } from '@angular/core'

export const IS_LOCALHOST = new InjectionToken<boolean>('IS_LOCALHOST', {
  providedIn: 'root',
  factory: () => new URL(inject(DOCUMENT).location.href).hostname === 'localhost',
})
